export const COLOR_PALETTES = ["blue", "lime", "teal", "honey"] as const;

export const DEFAULT_WIDTH = 120;
export const DEFAULT_HEIGHT = 120;
